export default {
  title: 'Order details',
};
